import React from "react";
import { getViewModel } from "../store/browse/actions";
import { useDispatch, useStore } from "../store";

export const useViewModel = (browsePath) => {
  const isLoading = useStore().browse?.[browsePath]?.isLoading;
  const hasError = useStore().browse?.[browsePath]?.hasError;
  const statusCode = useStore().browse?.[browsePath]?.statusCode;
  const viewModel = useStore().browse?.[browsePath]?.viewModel;
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!viewModel) {
      getViewModel(dispatch, browsePath);
    }
  }, [dispatch, viewModel, browsePath]);

  return [viewModel, isLoading, hasError, statusCode];
};
